import type { IconType } from 'react-icons'
import { LuBell, LuCircleCheck, LuClock, LuCopy, LuFileText, LuPencilLine, LuSparkles, LuUserPlus } from 'react-icons/lu'

export type NotificationFilter = 'jobs' | 'matches' | 'applications' | 'offers'

export type NotificationKind = {
    /** Row title. */
    label: string
    icon: IconType
    /** Which filter chip it falls under; general notifications only show under no filter. */
    filter: NotificationFilter | null
    /** Label for the row's link button. */
    action: string
}

export const NOTIFICATION_FILTERS: { value: NotificationFilter; label: string }[] = [
    { value: 'jobs', label: 'Jobs' },
    { value: 'matches', label: 'Matches' },
    { value: 'applications', label: 'Applications' },
    { value: 'offers', label: 'Offers' },
]

const GENERAL: NotificationKind = { label: 'Notification', icon: LuBell, filter: null, action: 'Open' }

// Keyed by the stored `notificationType` — the NotificationType values in src/app/utils/backend_utils.ts (server-only
// module, so not imported here).
const BY_TYPE: Record<string, NotificationKind> = {
    'Job Created': { label: 'Job created', icon: LuPencilLine, filter: 'jobs', action: 'Open job' },
    'Job Updated': { label: 'Job updated', icon: LuPencilLine, filter: 'jobs', action: 'Open job' },
    'Job Application Created': { label: 'New application', icon: LuUserPlus, filter: 'applications', action: 'View candidate' },
    'Duplicate Job Application': { label: 'Duplicate application', icon: LuCopy, filter: 'applications', action: 'View candidate' },
    'Job Application Approved': { label: 'Application approved', icon: LuCircleCheck, filter: 'applications', action: 'View candidate' },
    'Job Offer Created': { label: 'Offer created', icon: LuFileText, filter: 'offers', action: 'View offer' },
    'Job Offer Updated': { label: 'Offer updated', icon: LuFileText, filter: 'offers', action: 'View offer' },
    'Job Offer Approval Reminder': { label: 'Approval needed', icon: LuClock, filter: 'offers', action: 'Review offer' },
}

const MATCHES: NotificationKind = { label: 'Talent matches', icon: LuSparkles, filter: 'matches', action: 'Review matches' }

/** How a notification is shown and filtered. Talent-match results are stored as "Job Created", so their link decides. */
export function getNotificationKind(notification: { notificationType: string | null; link: string | null }): NotificationKind {
    if (notification.link?.includes('tab=find-talent')) return MATCHES
    return (notification.notificationType && BY_TYPE[notification.notificationType]) || GENERAL
}
